import { render, staticRenderFns } from "./experianBusinessOwnerProfileReport.vue?vue&type=template&id=fae07d2a"
import script from "./experianBusinessOwnerProfileReport.vue?vue&type=script&lang=js"
export * from "./experianBusinessOwnerProfileReport.vue?vue&type=script&lang=js"
import style0 from "./experianBusinessOwnerProfileReport.vue?vue&type=style&index=0&id=fae07d2a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports